import { useMutation } from '@tanstack/react-query';
import { POSTBankAccount } from '../requests';

interface UsePostBankAccountOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const usePostBankAccount = (options?: UsePostBankAccountOptions) => {
  return useMutation({
    mutationFn: POSTBankAccount,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};